import React from 'react';
import Rubricas from '../App/Esocial/Rubricas';

export default function Esocial (props) {
  return (
    <Rubricas {...props} />
  )
}
